import React, { useEffect } from 'react';

const CurrentAssignationsPagination = ({ handlePageClick, limit, assignationsByEmployee, nextPage, prevPage, state, pageCount, setpageCount, initialPage, finalPage, assignationsByEmployeeActive, inactiveAssignations }) => {

    useEffect(() => {
        if (inactiveAssignations) {
            setpageCount(Math.ceil(assignationsByEmployee.totalRecords / limit));
        } else {
            setpageCount(Math.ceil(assignationsByEmployeeActive.length / limit));
        }
    }, [assignationsByEmployee, assignationsByEmployeeActive, limit]);

    const pageNumbers: number[] = [];

    for (let i = 1; i <= pageCount; i++) {
        pageNumbers.push(i);
    };

    return (
        <nav className='pagination' aria-label='...'>
            <ul className='pagination justify-content-center mb-0'>
                <li className={state.currentPage === 1 ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`/employee/detail/${state.idEmployee}#employee`} aria-label="Initial" onClick={() => initialPage()}>
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                <li className={state.currentPage === 1 ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`/employee/detail/${state.idEmployee}#employee`} aria-label="Previous" onClick={() => prevPage()}>
                        <span aria-hidden="true">&lt;</span>
                    </a>
                </li>
                {pageNumbers.map(num => (
                    <li className={state.currentPage === num ? 'page-item active' : 'page-item'} key={num}>
                        <a className='page-link' href={`/employee/detail/${state.idEmployee}#employee`} onClick={() => handlePageClick(num)}>{num}</a>
                    </li> 
                ))}
                <li className={state.currentPage === pageCount ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`/employee/detail/${state.idEmployee}#employee`} aria-label="Next" onClick={() => nextPage()}>
                        <span aria-hidden="true">&gt;</span>
                    </a>
                </li>
                <li className={state.currentPage === pageCount ? 'page-item disabled' : 'page-item'}>
                    <a className='page-link' href={`/employee/detail/${state.idEmployee}#employee`} aria-label="Final" onClick={() => finalPage()}>
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </nav>
    )
}

export default CurrentAssignationsPagination;